import React, { Component } from 'react';
import { connect } from 'react-redux'
import { logOut } from '../Actions/Login'
import { Link } from 'react-router-dom'

import AppStack from './AppStack'
import Job from './Job'

class Resume extends Component {

	constructor(props){

       super(props);

    }

	render(){

		return (

			<AppStack className="resume">

				<section className="wysiwyg">

				<div className="container">

					<div className="page-title-container"><div className="page-title"><h1>Resume</h1></div></div>

					<div className="body">

					<div className="job -title"><br/><br/><h3>Proficiencies</h3><br/></div>

					<Job position="Frontend" company="React, Vue, Ember, Angular, Javascript, SASS, LESS" time="15+ Year Experience" location=""/>

					<Job position="Backend" company="Node, PHP, Laravel, Code Igniter" time="15+ Year Experience" location=""/>

					<Job position="Mobile" company="React Native, Swift" time="3 Years" location=""/>

					<Job position="Misc Tech" company="Gulp, Grunt, Webpack, MongoDB, MySQL, PostgreSQL, AWS, Google Cloud Platform, Firebase" time="" location=""/>

					<div className="job -title"><br/><br/>
					<h3>Experience</h3>
					<br/></div>

					<Job position="Director of Web" company="Fuzz Productions" time="2018 - Present" location="Brooklyn, New York" url="fuzzproductions.com" />
					<Job position="Full Stack Software Engineer" company="SportsRecruits" time="2018" location="Brooklyn, New York" url="sportsrecruits.com"/>
					<Job position="Founder" company="The Church Co" time="2017 - Present" location="Orlando, Florida" url="thechurchco.com"/>
					<Job position="Technical Lead" company="Agency" time="2015 - 2018" location="Sydney, Australia" url="agency.sc"/>
					<Job position="Lead PHP Developer" company="Hillsong" time="2012 - 2015" location="Sydney, Australia" url="hillsong.com"/>
					<Job position="Web Application & Database Developer" company="Advanced Micro Devices (AMD)" time="2004 - 2011" location="Orlando, Florida" url="amd.com"/>

					<div className="job -title"><br/><br/>
					<h3>Education</h3>
					<br/></div>

					<Job position="University of Central Florida" company="Bachelor of Arts in Digital Media, the Internet & Interactive Systems" time="Marketing Minor" location="Orlando, Florida"/>
					<Job position="Hillsong International Leadership College" company="Advanced Diploma in Ministry" time="Leadership & Coaching" location="Sydney, Australia"/>
					</div>
					</div>
				</section>


			</AppStack>
		);

	}

}



const mapStateToProps = (state) => {
	return { user: state.User };
}
const mapDispatchToProps = (dispatch) => {
	return {
		onLogout:() => { dispatch(logOut())}
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(Resume)



// WEBPACK FOOTER //
// ./src/Components/Resume.js